<template>
    <div class="not-found-container">
      <div class="not-found-content">
        <h1 class="not-found-heading">404</h1>
        <p class="not-found-text">Sorry, the page you are looking for does not exist.</p>
        <router-link to="/energywise/login" class="not-found-link">Go back to the home page</router-link>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "NotFound",
  };
  </script>
  
  <style scoped>
  /* Additional CSS for styling the 404 Not Found page */
  .not-found-container {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100vh;
    background-color: #f0f0f0;
  }
  
  .not-found-content {
    text-align: center;
    padding: 20px;
  }
  
  .not-found-heading {
    font-size: 64px;
    color: #d9534f; /* You can change the color as per your preference */
  }
  
  .not-found-text {
    font-size: 24px;
    margin-top: 10px;
    color: #333;
  }
  
  .not-found-link {
    display: inline-block;
    margin-top: 20px;
    padding: 10px 20px;
    background-color: #007bff;
    color: #fff;
    text-decoration: none;
    border-radius: 5px;
    font-size: 16px;
    transition: background-color 0.3s;
  }
  
  .not-found-link:hover {
    background-color: #0056b3;
  }
  </style>
  